import { FormattedDate, FormattedMessage, useIntl } from 'react-intl';
import SimpleTooltip from '@rio-cloud/rio-uikit/SimpleTooltip';

import { HighestOverdueOrigin } from '@/generated/GeneratedApiTypes';

interface HighestEngineOilOverdueTooltipProps {
    serviceDate: string | undefined;
    isCurrent: boolean | undefined;
    origin: HighestOverdueOrigin | undefined;
}

const chooseCorrectOriginMessage = (origin: HighestOverdueOrigin | undefined) => {
    const intl = useIntl();
    switch (origin?.toLowerCase()) {
        case 'consumption':
            return intl.formatMessage({ id: 'intl-msg:maintenanceHistory.lifetime.highest.fuelConsumption' });
        case 'mileage':
            return intl.formatMessage({ id: 'intl-msg:maintenanceHistory.lifetime.highest.mileage' });
        case 'time':
            return intl.formatMessage({ id: 'intl-msg:maintenanceHistory.lifetime.highest.time' });
        default:
            return '';
    }
};

const HighestEngineOilOverdueTooltip = ({ serviceDate, isCurrent, origin }: HighestEngineOilOverdueTooltipProps) => {
    return (
        <SimpleTooltip
            data-testid={'engine-oil-change-status-tooltip'}
            content={
                <FormattedMessage
                    id={
                        isCurrent
                            ? 'intl-msg:maintenanceHistory.lifetime.maximumEngineOilChangeOverdueCurrent.tooltip'
                            : 'intl-msg:maintenanceHistory.lifetime.maximumEngineOilChangeOverduePast.tooltip'
                    }
                    values={{
                        date: <FormattedDate value={serviceDate} year="numeric" month="numeric" day="numeric" />,
                        origin: chooseCorrectOriginMessage(origin),
                    }}
                />
            }
            textAlignment={isCurrent ? 'left' : undefined}
            innerClassName={isCurrent ? 'padding-y-5' : undefined}
        >
            <span
                data-testid={'engine-oil-change-status-icon-tooltip'}
                className="rioglyph rioglyph-info-sign text-size-16 margin-left-5"
            />
        </SimpleTooltip>
    );
};
export default HighestEngineOilOverdueTooltip;
